// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-item[data-v-52b65a62] {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #323653;\n}\n.list-item-bullet[data-v-52b65a62] {\n  display: block;\n  margin-right: 10px;\n  margin-bottom: 0;\n  min-width: 16px;\n}", ""]);
// Exports
module.exports = exports;
